export const IncludeInTruckDepreciation = (truck) => {
  if (!truck) return false;
  return !(
    !truck?.initialValue ||
    !truck?.purchaseDate ||
    !truck?.depreciationYears
  );
};
